import HRMLanding from '@/views/landing/CommonLanding';

export default [{
    path: '/hrm/landing',
    name: 'hrmlanding',
    component: HRMLanding,
    meta: { layout: 'landing', accessedby: 'HRM' }
}];